<!-- TODO: AJ - remove all popup references -->
<section class="field-config scrollable-container">
  @if (theField) {
    <header>
      <h2 class="title heading-underline">
        <span>{{ theField.label }} <span class="grey">options</span></span
        ><mat-icon (click)="closeFieldConfig()" (keydown.space)="closeFieldConfig()" title="Close field options" tabindex="0"
        >close</mat-icon
        >
      </h2>
    </header>
    <article id="popup-scroll" class="scrollable-container">
      <ul class="popup-sections striped-h">
        @if (!config.useDisplayValue) {
          @if (theField.type === FieldType.DOUBLE) {
            <li>
              <app-format-decimal [(fieldOptions)]="config.decimalFormat"></app-format-decimal>
            </li>
          }
          @if (theField.type === FieldType.INTEGER) {
            <li>
              <app-format-integer [(fieldOptions)]="config.integerFormat"></app-format-integer>
            </li>
          }
          @if (theField.type === FieldType.DATE) {
            <li>
              <app-date-format [(fieldOptions)]="config.dateFormatOptions"></app-date-format>
            </li>
          }
          <!-- booleans are treated as strings, so they get the string formatting options too -->
          @if (theField.type === FieldType.STRING || theField.type === FieldType.BOOLEAN) {
            <li>
              <app-string-format [(fieldOptions)]="config.stringFormat"></app-string-format>
            </li>
          }
          @if (theField.type === FieldType.TO_MANY) {
            <ng-container class="to-many">
              <li>
                <app-field-conditions [srcFields]="sortedFields" [(fieldOptions)]="config.conditions"></app-field-conditions>
              </li>
              <li>
                <app-sort-options [srcFields]="sortedFields" [(fieldOptions)]="config.sortOption"></app-sort-options>
              </li>
              <li><app-limit [(fieldOptions)]="config.limit"></app-limit></li>
            </ng-container>
          }
        }
        @if (!isAssociatedField(theField.type)) {
          <li>
            <app-blank-field-default [(fieldOptions)]="config.defaultEmptyValue"></app-blank-field-default>
          </li>
        }
        @if (FieldMetaTypeGuards.hasOptions(theField)) {
          <li>
            <app-presentation-options [field]="theField" [(fieldOptions)]="config.useDisplayValue"></app-presentation-options>
          </li>
        }
      </ul>
    </article>
  }
</section>
